"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _style = _interopRequireDefault(require("./style.css"));
var _OpenClosedButtonGroup = _interopRequireDefault(require("../../../../components/OpenClosedButtonGroup"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TimeConfig = /*#__PURE__*/function (_React$Component) {
  _inherits(TimeConfig, _React$Component);
  var _super = _createSuper(TimeConfig);
  function TimeConfig() {
    _classCallCheck(this, TimeConfig);
    return _super.apply(this, arguments);
  }
  _createClass(TimeConfig, [{
    key: "render",
    value: function render() {
      var _this$props$fields = this.props.fields,
        open = _this$props$fields.open,
        opensOn = _this$props$fields.opensOn,
        closesOn = _this$props$fields.closesOn;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].timeConfig
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: open,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Currently",
          tooltip: "You may open or close data collection."
        })
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_OpenClosedButtonGroup["default"], {
        wrapperClassName: "btn-group btn-group-sm",
        isOpen: open.value,
        setOpen: open.onChange
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: opensOn,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Opens On",
          tooltip: "When would you like to allow responses?",
          optional: true
        })
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.DatePicker, {
        field: opensOn,
        placeholder: "Pick date & time",
        showTimeSelect: true
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: closesOn,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Closes On",
          tooltip: "When would you like to stop accepting responses?",
          optional: true
        })
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.DatePicker, {
        field: closesOn,
        placeholder: "Pick date & time",
        showTimeSelect: true
      }))));
    }
  }]);
  return TimeConfig;
}(_react["default"].Component);
exports["default"] = TimeConfig;
_defineProperty(TimeConfig, "propTypes", {
  fields: _propTypes["default"].object
});